
















































































































import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    PropType,
    watch,
    onMounted,
} from '@vue/composition-api';

import { getQrcode, scanResult, acceptResult } from '@/apis/controll';
import { handleErrorMessageToast } from '@/common/util';
const errorMessage = {
    timeout: '二维码过期',
    fail: '获取二维码失败，请刷新',
    abandon: '已取消',
    accept: '验证成功',
    scanned: '扫码成功，请在手机上确认',
};

export default defineComponent({
    name: 'auth-confirm',
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        registerMail: {
            type: String,
            default: '',
        },
        accountId: {
            type: Number,
            default: -1,
        },
        qrType: {
            type: String,
            default: '',
        },
        operation: {
            type: String,
            default: '',
        },
        sendMailCode: {
            type: Function,
            default: () => {
                return () => {};
            },
        },
        submitMailAuth: {
            type: Function,
            default: () => {
                return () => {};
            },
        },
        prior: {
            type: String,
            default: '',
        },
    },
    setup(props, context) {
        const state: {
            activeIndex: string;
            qrCodeUrl: string;
            qrStatus:
                | 'fail'
                | 'timeout'
                | 'accept'
                | 'scanned'
                | 'abandon'
                | '';
            statusMessage: string;
            emailCode: string;
            emailCodeErrMsg: string;
            timeLimit: number;
            countDownTimer: any;
        } = reactive({
            activeIndex: props.prior || 'qrcode',
            qrCodeUrl: '',
            qrStatus: '',
            statusMessage: '',
            emailCode: '',
            emailCodeErrMsg: '',
            timeLimit: 0,
            countDownTimer: 0,
        });
        function initState() {
            state.emailCode = '';
            state.emailCodeErrMsg = '';
            state.timeLimit = 0;
            clearTimeout(state.countDownTimer);
        }
        function cancelScan() {
            try {
                (scanResult as any).cancel();
                (scanResult as any).hasCancel = true;
            } catch (e) {
                // console.log(e);
            }
        }
        function closeAuth() {
            cancelScan();
            initState();
            context.emit('cancel');
            state.activeIndex = props.prior;
        }
        // 不注释会报错，在平台融合的时候，引用这个组件的两个入口已经下线，所以这个代码目前不在使用了
        // 1、platform/profile/enterprise
        // 2、platform/profile/user
        // 以上两个路由替换为 platform/account

        // async function refresh() {
        //     state.qrCodeUrl = '';
        //     state.qrStatus = '';
        //     state.statusMessage = '';
        //     try {
        //         const qrStart = await getQrcode(props.qrType, {
        //             accountId: +props.accountId,
        //             operation: props.operation,
        //         });
        //         if (qrStart.data.result !== 1) {
        //             state.qrStatus = 'fail';
        //             state.statusMessage = errorMessage[state.qrStatus];
        //             return;
        //         }
        //         state.qrCodeUrl = `data:image/PNG;base64,${qrStart.data.imageData}`;
        //         const qrScan = await scanResult(
        //             qrStart.data.qrLoginToken!,
        //             qrStart.data.qrLoginSignature!,
        //         );
        //         if (qrScan.data.result !== 1) {
        //             state.qrStatus = 'timeout';
        //             state.statusMessage = errorMessage[state.qrStatus];
        //             return;
        //         }
        //         state.qrStatus = 'scanned';
        //         state.statusMessage = Reflect.get(errorMessage, state.qrStatus);
        //         const qrAccept = await acceptResult(
        //             qrStart.data.qrLoginToken!,
        //             qrScan.data.qrLoginSignature,
        //         );
        //         if (qrAccept.data.result !== 1) {
        //             state.qrStatus = 'abandon';
        //             state.statusMessage = errorMessage[state.qrStatus];
        //             closeAuth();
        //             return;
        //         }
        //         state.qrStatus = 'accept';
        //         state.statusMessage = errorMessage[state.qrStatus];
        //         context.emit('success', qrAccept.data.serviceOwnToken);
        //     } catch {
        //         state.qrStatus = 'fail';
        //         state.statusMessage = errorMessage[state.qrStatus];
        //     }
        // }
        function isCodeEmpty() {
            if (!state.emailCode) {
                state.emailCodeErrMsg = '请输入正确的验证码';
                return;
            }
            state.emailCodeErrMsg = '';
        }
        function loopCheck() {
            state.timeLimit--;
            if (state.timeLimit) {
                state.countDownTimer = setTimeout(() => {
                    loopCheck();
                }, 1000);
            }
        }
        async function getEmailCode() {
            // @ts-ignore
            await props.sendMailCode({ mail: props.registerMail });
            state.timeLimit = 60;
            loopCheck();
        }
        async function submitEmailAuth() {
            try {
                // @ts-ignore
                const res = await props.submitMailAuth({
                    code: state.emailCode,
                    mail: props.registerMail,
                    operation: props.operation,
                });
                if (res.result === 1) {
                    context.emit('success', res.data.operateToken);
                    return;
                }
                handleErrorMessageToast(res.error_msg);
            } catch (e) {
                handleErrorMessageToast(e);
            }
        }
        watch(
            () => state.activeIndex && props.isShow,
            async (v) => {
                if (!props.isShow) {
                    return;
                }
                if (state.activeIndex === 'qrcode') {
                    // await refresh();
                } else {
                    state.qrCodeUrl = '';
                    cancelScan();
                }
            },
            { immediate: true, deep: true },
        );
        watch(
            () => props.prior,
            () => {
                state.activeIndex = props.prior;
            },
        );

        return {
            // refresh,
            isCodeEmpty,
            getEmailCode,
            submitEmailAuth,
            closeAuth,
            ...toRefs(state),
        };
    },
});
